import { Component, input } from '@angular/core';

@Component({
	selector: 'eye-icon',
	templateUrl: './eye-icon.html',
	standalone: true
})
export class EyeIconComponent {
	color = input<string>('#000000');
	size = input<number>(20);
}

